import axios from '../axios'
import {
    HOLE_CREATE_REQUEST, HOLE_CREATE_SUCCESS, HOLE_CREATE_FAIL,
    HOLE_UPDATE_REQUEST, HOLE_UPDATE_SUCCESS, HOLE_UPDATE_FAIL,
    HOLE_DELETE_REQUEST, HOLE_DELETE_SUCCESS, HOLE_DELETE_FAIL,
} from '../constants/holeConstants'

const multipartHeader = (userInfo) => ({
    headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'multipart/form-data',
    },
})

const authHeader = (userInfo) => ({
    headers: { Authorization: `Bearer ${userInfo.token}` },
})

export const createHole = (courseId, formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: HOLE_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(
            `/api/courses/${courseId}/holes/create/`,
            formData,
            multipartHeader(userInfo)
        )
        dispatch({ type: HOLE_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: HOLE_CREATE_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}

export const updateHole = (holeId, formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: HOLE_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(
            `/api/courses/holes/update/${holeId}/`,
            formData,
            multipartHeader(userInfo)
        )
        dispatch({ type: HOLE_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: HOLE_UPDATE_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}

export const deleteHole = (holeId) => async (dispatch, getState) => {
    try {
        dispatch({ type: HOLE_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(
            `/api/courses/holes/delete/${holeId}/`,
            authHeader(userInfo)
        )
        dispatch({ type: HOLE_DELETE_SUCCESS })
    } catch (error) {
        dispatch({
            type: HOLE_DELETE_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}
